'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AnchorDatePage } from '../-components/AnchorDatePage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-offboarding/anchor-date/')({
  component: AnchorDatePage
});